export default () => ({
  current: 0,
  leaving: -1,
  entering: -1,
  count: 0,
  duration: 7000,
  progress: 0,
  raf: null,
  start: 0,
  paused: false,
  pausedAt: 0,
  needsReset: false,
  hovered: false,
  visible: true,

  init() {
    this.count = this.$refs.track.children.length;
    this.duration = parseInt(this.$el.dataset.duration) || 7000;
    this.$el.addEventListener('mouseenter', () => {
      this.hovered = true;
      this.pause();
    });
    this.$el.addEventListener('mouseleave', () => {
      this.hovered = false;
      this.resumeIfActive();
    });
    this.initSwipe();
    this.startAutoplay();
  },

  /**
   * Touch swipe navigation (mobile). A horizontal drag past the threshold
   * advances to the next/previous slide. Vertical drags are ignored so the
   * page can still scroll. Listeners are passive (we never preventDefault).
   */
  initSwipe() {
    if (this.count < 2) return;
    const threshold = 40;
    let startX = 0;
    let startY = 0;
    let tracking = false;

    this.$el.addEventListener(
      'touchstart',
      (e) => {
        const t = e.changedTouches[0];
        startX = t.clientX;
        startY = t.clientY;
        tracking = true;
      },
      { passive: true },
    );

    this.$el.addEventListener(
      'touchend',
      (e) => {
        if (!tracking) return;
        tracking = false;
        const t = e.changedTouches[0];
        const dx = t.clientX - startX;
        const dy = t.clientY - startY;
        // Only treat as a swipe when mostly horizontal and past the threshold.
        if (Math.abs(dx) > threshold && Math.abs(dx) > Math.abs(dy)) {
          if (dx < 0) {
            this.next();
          } else {
            this.prev();
          }
        }
      },
      { passive: true },
    );
  },

  goTo(index) {
    if (index === this.current) return;
    this.transition(index);
    this.progress = 0;
    this.needsReset = true;
    this.pause();
  },

  transition(next) {
    this.leaving = this.current;
    this.entering = next;
    this.current = -1;
    setTimeout(() => {
      this.current = next;
      this.leaving = -1;
      this.entering = -1;
    }, 350);
  },

  next() {
    if (this.count < 2) return;
    const next = (this.current + 1) % this.count;
    this.transition(next);
    this.resetProgress();
  },

  prev() {
    if (this.count < 2) return;
    const prev = (this.current - 1 + this.count) % this.count;
    this.transition(prev);
    this.resetProgress();
  },

  resetProgress() {
    this.progress = 0;
    this.start = performance.now();
  },

  tick(now) {
    if (this.paused) return;
    this.progress = Math.min((now - this.start) / this.duration, 1);
    if (this.progress >= 1) {
      this.next();
    }
    this.raf = requestAnimationFrame((t) => this.tick(t));
  },

  pause() {
    this.paused = true;
    this.pausedAt = performance.now();
    cancelAnimationFrame(this.raf);
  },

  resume() {
    if (this.count < 2) return;
    if (!this.paused) return;
    this.paused = false;
    if (this.needsReset) {
      this.needsReset = false;
      this.resetProgress();
    } else {
      this.start += performance.now() - this.pausedAt;
    }
    this.raf = requestAnimationFrame((t) => this.tick(t));
  },

  resumeIfActive() {
    if (!this.hovered && this.visible) this.resume();
  },

  onEnterViewport() {
    this.visible = true;
    this.resumeIfActive();
  },

  onLeaveViewport() {
    this.visible = false;
    this.pause();
  },

  startAutoplay() {
    if (this.count < 2) return;
    this.resetProgress();
    this.raf = requestAnimationFrame((t) => this.tick(t));
  },

  restartAutoplay() {
    cancelAnimationFrame(this.raf);
    this.paused = false;
    this.startAutoplay();
  },

  destroy() {
    cancelAnimationFrame(this.raf);
  },
});
